import { render, staticRenderFns } from "./SidebarPc.vue?vue&type=template&id=6b8152f5&"
import script from "./SidebarPc.vue?vue&type=script&lang=ts&"
export * from "./SidebarPc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports